import { ActionContext } from "vuex";
import api, {
  PostCloudContractsChangePlansEstimateRequest,
  PostCloudContractsChangePlansRequest,
  PostCloudContractsChangePlansRevokeRequest
} from "@/containers/cloudContractsChangePlans/api";
import log from "loglevel";

type State = {};

type MyActionContext = ActionContext<State, State>;

export default {
  namespaced: true,
  state: {} as State,
  getters: {},
  actions: {
    // CLOUD容量販売プラン変更の見積もりAPI実行
    async postCloudContractsChangePlansEstimate(
      context: MyActionContext,
      params: PostCloudContractsChangePlansEstimateRequest
    ) {
      try {
        const res = await api.postCloudContractsChangePlansEstimate(params);
        return res.data;
      } catch (error) {
        log.error("postCloudContractsChangePlansEstimate error:", error);
        throw error;
      }
    },

    // CLOUD容量販売プラン変更の契約変更API実行
    async postCloudContractsChangePlans(
      context: MyActionContext,
      params: PostCloudContractsChangePlansRequest
    ) {
      try {
        const res = await api.postCloudContractsChangePlans(params);
        return res.data;
      } catch (error) {
        log.error("postCloudContractsChangePlans error:", error);
        throw error;
      }
    },

    // CLOUD容量販売プラン変更の契約変更予約キャンセルAPI実行
    async postCloudContractsChangePlansRevoke(
      context: MyActionContext,
      params: PostCloudContractsChangePlansRevokeRequest
    ) {
      try {
        const res = await api.postCloudContractsChangePlansRevoke(params);
        return res.data;
      } catch (error) {
        log.error("postCloudContractsChangePlans error:", error);
        throw error;
      }
    }
  }
};
